import { Theme } from '@mui/material';
import { resolveTypographyVariantStyles } from '@aspendental/themes';

export const locationsWrapStyles = {
	height: 'auto',
	padding: { xs: '0 2.5rem 1.5rem', md: '0 1.5rem 1.5rem 2.5rem' },
	order: { xs: 1, md: 0 },
};

export const locationsListStyles = {
	overflowY: 'auto',
	height: { md: 'calc(100% - 10rem)' },
	display: 'flex',
	flexDirection: 'column',
	gap: '1rem',
};

export const stateLocationsGridStyles = {
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	gap: '0.5rem',
};

export const getHeadingStyles = (theme: Theme, titleVariant: string) => ({
	...resolveTypographyVariantStyles(theme, titleVariant),
});

export const buttonStyles = {
	padding: 0,
};

export const mapAndLocationsComponentStyles = {
	display: 'flex',
	height: { md: 'calc(100vh - 13rem)' },
	justifyContent: 'flex-start',
};

export const stateLocationsGridItemStyles = {
	display: 'flex',
	flexDirection: 'column',
	gap: '1rem',
	marginBottom: '1rem',
};
